import * as React from 'react';

import SvgIcon, { SvgIconProps } from './SvgIcon';

const X: React.FC<SvgIconProps> = React.memo((props) => {
  return (
    <SvgIcon viewBox="0 0 30 30" {...props}>
      <path
        d="M22.1885 3.75H26.0219L17.6469 13.3229L27.5 26.3469H19.7854L13.7437 18.4469L6.82917 26.3469H2.99375L11.9521 16.1073L2.5 3.75104H10.4104L15.8719 10.9719L22.1885 3.75ZM20.8438 24.0531H22.9677L9.25625 5.92396H6.97708L20.8438 24.0531Z"
        fill="white"
      />
    </SvgIcon>
  );
});

export default X;
